import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type LiveListenMode = 'manual' | 'auto'

export interface LiveListenState {
  mode: LiveListenMode
}

const initialState: LiveListenState = {
  mode: 'manual',
}

export const liveListenSlice = createSlice({
  name: 'liveListen',
  initialState,
  reducers: {
    setLiveListenMode(state, action: PayloadAction<LiveListenMode>) {
      state.mode = action.payload
    },
  },
})

export const { setLiveListenMode } = liveListenSlice.actions


